import React from 'react';
import { Switch, Route } from 'react-router-dom';
// sub pages
import { Page404 } from 'pages/errors';
import MissionAccessPage from './MissionAccessPage';

function MissionAccessIndexPage ({ match }) {
  return (
    <Switch>
      <Route path={ match.path } exact component={ MissionAccessPage } />
      <Route component={ Page404 } />
    </Switch>
  )
}

export default MissionAccessIndexPage;



// WEBPACK FOOTER //
// ./src/pages/base-managment/missionAccess/index.jsx